export function capitalizeEveryWord(string) {
  if (!string) {
    return string;
  }

  return string
    .toLowerCase()
    .replace(/(?:[A-Z]|\b\w)/g, letter => letter.toUpperCase());
}


/** WEBPACK FOOTER **
 ** ./src/lib/StringUtils.js
 **/